import { t } from "@/i18n-js/instance";
import { InputFilterComparator } from "@circle-react-shared/Filter/FilterTypes/InputFilterComparator/InputFilterComparatorV2";
import type { StringComparatorParam } from "@circle-react-shared/Filter/FilterTypes/InputFilterComparator/stringComparators";
import {
  handleStringComparatorApply,
  renderTextSelectedItem,
  stringComparatorsIncludingExistence,
} from "@circle-react-shared/Filter/FilterTypes/InputFilterComparator/stringComparators";
import { Filter } from "@circle-react-shared/FilterV3";
import { useAudienceSearchContext } from "../AudienceSearchContext";

const localeNamespace = "members_directory.header.search.filters";

interface LocationFilterProps {
  isInitialOpen?: boolean;
  onApply?: (value: StringComparatorParam | null) => void;
  param: StringComparatorParam;
}

export const LocationFilter = ({
  isInitialOpen,
  onApply,
  param,
}: LocationFilterProps) => {
  const { isContactsSearch } = useAudienceSearchContext();

  return (
    <Filter onApply={value => handleStringComparatorApply(value, onApply)}>
      <Filter.Chip renderSelectedValue={() => renderTextSelectedItem(param)}>
        {t([localeNamespace, "location"])}
      </Filter.Chip>

      <Filter.Popover
        title={t([localeNamespace, "location_title"])}
        isInitialOpen={isInitialOpen}
      >
        <InputFilterComparator
          name="location"
          param={param}
          placeholder={t([localeNamespace, "location_placeholder"])}
          comparators={
            isContactsSearch ? stringComparatorsIncludingExistence : undefined
          }
        />
      </Filter.Popover>
    </Filter>
  );
};
